var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      staticClass: "fill-height"
    },
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            {
              staticClass: "align-items-center text-center fill-height"
            },
            [
              _vm.status === "Pending"
                ? _c("gg-card-text", [
                    _c("b", [
                      _vm._v("Your service is pending. Please check back soon.")
                    ])
                  ])
                : _vm._e(),
              _vm.status === "Suspended"
                ? _c("v-card-text", [
                    _c("b", [
                      _vm._v(
                        "Your service is suspended. Please contact Support."
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }